import { useEffect } from 'react';
import { showMessage } from '../actions';

export function useLazyStyles(shouldLoad, loadStyles, stylesheetName) {
  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    loadStyles().catch(error => {
      console.error(`Error loading ${stylesheetName} styles`, error);
      showMessage(`Error loading ${stylesheetName} styles: ${error}`);
    });
  }, [shouldLoad, loadStyles, stylesheetName]);
}
